export enum EmployeeType {
    "Invalid Employee Type" = -1,
    "Employee" = 1,
    "Employed by Other" = 2,
    "Unemployed" = 3,
    "Employee Previously Unemployed" = 4,
}